import React, { useContext } from 'react';
import { GrLocation } from 'react-icons/gr';
import { HiOutlineBriefcase } from 'react-icons/hi2';
import { MdDeleteOutline } from "react-icons/md";
import { FaBuilding } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";
import SuperAdminContext from '../../hooks/SuperAdminContext';

const RecommendedJobCard = ({ heading, contentOne, contentTwo, id, key, image, cardType, handleDeleteRecommended, deletingCardId, icon }) => {
    const{deletionContent,setDeletionContent,deleteRecommendationId,setDeleteRecommendationId}=useContext(SuperAdminContext);

    return (
        <div className="col-12 col-sm-6 col-xl-4 py-2 d-inline-flex align-items-stretch" key={key}>
            <div className="d-flex flex-wrap border rounded-2 w-100 p-3 pe-0">
                {
                    cardType ?
                        deletingCardId !== id ?
                            <>
                                <div className="col-3">
                                    <img
                                        src={image}
                                        alt=""
                                        width={50}
                                        height={50}
                                        className="rounded-circle"
                                    />
                                </div>
                                <div className="col-9">
                                    <div className="container-fluid position-relative">
                                        <p className='mb-0 pb-1 superAdmin-recommended-card-heading'>{heading}</p>
                                        <p className="mb-0 superAdmin-recommended-card-sub-content">
                                            <span className="pe-2"><HiOutlineBriefcase /></span>
                                            {contentOne}
                                        </p>
                                        <p className="mb-0 superAdmin-recommended-card-sub-content">
                                            <span className="pe-2"><GrLocation /></span>
                                            {contentTwo}
                                        </p>

                                        <div className="recomendedCard_Absolute" onClick={()=>{
                                            setDeletionContent(heading);
                                            setDeleteRecommendationId(id);
                                        }}>
                                            <MdDeleteOutline className='fs-4'  data-bs-toggle="modal" data-bs-target="#deleteModal" />
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                <div className="col-3 placeholder rounded-circle pe-none">
                                    <img
                                        src={""}
                                        width={48}
                                        height={48}
                                        className="opacity-0 d-block"
                                        alt="..."
                                    />
                                </div>
                                <div className="col-9">
                                    <div className="container-fluid">
                                        <p className='mb-0 pb-1 superAdmin-recommended-card-heading placeholder rounded-2 w-100 py-3 mb-1'></p>
                                        <p className="mb-0 superAdmin-recommended-card-sub-content mb-1">
                                            <span className="pe-2 placeholder rounded-2"><HiOutlineBriefcase /></span>
                                            <span className="placeholder rounded-2 w-50 py-2 ms-2"></span>
                                        </p>
                                        <p className="mb-0 superAdmin-recommended-card-sub-content">
                                            <span className="pe-2 placeholder rounded-2"><GrLocation /></span>
                                            <span className="placeholder rounded-2 w-50 py-2 ms-2"></span>
                                        </p>
                                    </div>
                                </div>
                            </>
                        :
                        <div className='row align-items-center'>
                            <div className="col-3 recommended-div-plus">
                                {
                                    icon === "building" ?
                                        <FaBuilding className='fs-1 recommended-div-plus-icon' />
                                        :
                                        <CgProfile className='fs-1 recommended-div-plus-icon' />
                                }
                            </div>
                            <div className="col-8 ps-2 p-0">
                                <p className='superAdmin-recommended-card-sub-content mb-0'>
                                    Your recommendations will appear here
                                </p>
                            </div>
                        </div>

                }
            </div>

            <div className="modal fade" id="deleteModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header justify-content-around"> 
                            <h5 className="modal-title" id="exampleModalLabel">Delete</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body py-5 px-3">
                            <p>Are you sure do you want to delete <strong>{deletionContent}</strong> in the recommendation</p>
                        </div>
                        <div className="modal-footer">
                            <div className="w-100 row">
                                <div className="col-6">
                                    <button type="button" className="btn btn-secondary w-100" data-bs-dismiss="modal">Cancel</button>
                                </div>
                                <div className="col-6">
                                    <button type="button" className="btn btn-brand-color w-100" data-bs-dismiss="modal" onClick={() => handleDeleteRecommended(deleteRecommendationId)}>Delete</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RecommendedJobCard